import React from 'react';
import './Footer.css';
import gpt3Logo from '../../assets/logo.svg';

const Footer = () => {
  return (
    <section className='footer-section'>

      <div className='footer-heading-container'>
        <h1 className='gradient_text'>
          Do you want to step in to the Future before others
        </h1>
      </div>

      <div className='footer-button-container'>
        <button className='footer-btn'>Request Early Access</button>
      </div>

      <div className='footer-container'>

        <div className='footer-logo-container'>
          <img src={gpt3Logo} alt="Footer Logo" />
          <p>
            Crechterwoord K12 182 DK
            <br/>Alknjkcb, All Rights Reserved
          </p>
        </div>

        <div className='footer-links-container'>
          <h4>Links</h4>
          <ul className='footer-links-list'>
            <li><a href="">Overons</a></li>
            <li><a href="">Social Media</a></li>
            <li><a href="">Counters</a></li>
            <li><a href="">Contact</a></li>
          </ul>
        </div>

        <div className='footer-links-container'>
          <h4>Company</h4>
          <ul className='footer-links-list'>
            <li><a href="">Terms & Conditions</a></li>
            <li><a href="">Privacy Policy</a></li>
            <li><a href="">Contact</a></li>
          </ul>
        </div>

        <div className='footer-links-container'>
          <h4>Links</h4>
          <ul className='footer-links-list'>
            <li><a href="">Crechterwoord K12 <br />182 DK Alknjkcb</a></li>
            <li><a href="">002 - 851327</a></li>
            <li><a href="">info@openai.net</a></li>
          </ul>
        </div>

      </div>

      <div className='footer-copyright'>
        <p>2023 GPT-3. All rights reserved</p>
      </div>

    </section>
  )
}

export default Footer
